import React, { useState, useEffect } from 'react';
import { Film } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { MovieCard } from '../components/MovieCard';
import { myListApi } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const MyListPage = () => {
  const [films, setFilms] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    const fetchMyList = async () => {
      try {
        const data = await myListApi.getAll();
        setFilms(data);
      } catch (error) {
        console.error('Failed to fetch my list:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMyList();
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen bg-[#030014]" data-testid="my-list-page">
      <Navbar />

      <div className="pt-24 pb-12 w-full px-4 md:px-8 lg:px-[4%]">
        {/* Header */}
        <div className="mb-8">
          <h1
            className="text-3xl md:text-4xl font-bold tracking-tighter"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            My List
          </h1>
          <p className="text-gray-400 mt-2">
            {films.length} {films.length === 1 ? 'film' : 'films'} saved
          </p>
        </div>

        {/* Films Grid */}
        {loading ? (
          <div className="flex justify-center py-20">
            <div className="spinner" />
          </div>
        ) : films.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
            {films.map((film) => (
              <div key={film.film_id} className="flex justify-center">
                <MovieCard film={film} />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <Film className="w-16 h-16 mx-auto text-gray-600 mb-4" />
            <h2 className="text-xl font-semibold mb-2">Your list is empty</h2>
            <p className="text-gray-400 mb-6">
              Add films to your list to watch them later
            </p>
            <button
              onClick={() => navigate('/browse')}
              className="btn-primary"
              data-testid="browse-button"
            >
              Browse Films
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyListPage;
